/*
 * ******************************************************************
 * Copyright (c) 2022-2025 Broadcom. All Rights Reserved.
 * Broadcom Confidential. The term "Broadcom" refers to Broadcom Inc.
 * and/or its subsidiaries.
 * ******************************************************************
 */
import { Component, Input } from "@angular/core";

// @formatter:off
@Component({
    standalone: false,
    selector: 'property-value',
    templateUrl: './property-value.component.html',
    styleUrls: ['./property-value.component.scss']
})
// @formatter:on
export class PropertyValueComponent {

    @Input()
    name: string;

    @Input()
    id: string;

    constructor() {
    }
}
